import React, { useCallback } from "react";
import { throttle } from "../../utils/debounceThrottle";

export default function ViewTypeToggle({ viewType, setViewType, handleRefresh }) {
  // Throttle view type changes to prevent rapid processing (500ms)
  const throttledSetViewType = useCallback(
    throttle((newViewType) => {
      setViewType(newViewType);
    }, 500),
    [setViewType]
  );
  
  // Throttle refresh button to prevent rapid clicks (2000ms)
  const throttledHandleRefresh = useCallback(
    throttle(() => {
      if (handleRefresh) handleRefresh();
    }, 2000),
    [handleRefresh]
  );
  
  return (
    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
      <button
        onClick={() => throttledSetViewType("daily")}
        style={{
          padding: "6px 12px",
          border: "1px solid #e6e9ef",
          borderRadius: 4,
          background: viewType === "daily" ? "#0073ea" : "#ffffff",
          color: viewType === "daily" ? "#ffffff" : "#323338",
          cursor: "pointer",
          fontSize: 14,
          fontWeight: viewType === "daily" ? 600 : 400,
        }}
      >
        Daily
      </button>
      <button
        onClick={() => throttledSetViewType("weekly")}
        style={{
          padding: "6px 12px",
          border: "1px solid #e6e9ef",
          borderRadius: 4,
          background: viewType === "weekly" ? "#0073ea" : "#ffffff",
          color: viewType === "weekly" ? "#ffffff" : "#323338",
          cursor: "pointer",
          fontSize: 14,
          fontWeight: viewType === "weekly" ? 600 : 400,
        }}
      >
        Weekly
      </button>
      <button
        onClick={throttledHandleRefresh}
        style={{
          padding: "6px 12px",
          border: "1px solid #e6e9ef",
          borderRadius: 4,
          background: "#ffffff",
          color: "#323338",
          cursor: "pointer",
          fontSize: 14,
          marginLeft: 8,
        }}
        title="Refresh"
      >
        ↻
      </button>
    </div>
  );
}

